import { Edge } from 'reactflow';

export const NoWorkflowFoundEdges: Edge[] = [
  { id: 'e1-2', source: 'input-node', target: 'center-node', type: 'smoothstep',animated: true, style: { stroke: "#3D85C6", strokeWidth: 2, strokeDasharray: "4 2" }, labelStyle: { fill: "#333", fontSize: 12 }, },
  { id: 'e2-3', source: 'center-node', target: 'output-node', type: 'smoothstep',animated: true, style: { stroke: "#3D85C6", strokeWidth: 2, strokeDasharray: "4 2" }, labelStyle: { fill: "#333", fontSize: 12 }, },
];
